export const CONNECTOR_STORE_KEY = 'connector';
export const CONNECTOR_SERVICE_KEY = 'connector';
export const CONNECTOR_API_URL = '/api/v1/connector/';
